// A moderação trocou o apelido (por "Jogador" e 4 dígitos): antes de jogar, a pessoa escolhe outro. O apelido novo
// vai pela API, que confere o filtro de palavras ofensivas; aqui o mesmo filtro avisa antes de enviar.
import { useState } from 'react';
import { ofensivo } from '@truco6/moderacao';
import { api, ErroDaApi } from '../comum/api.ts';
import { config } from '../comum/config.ts';
import { conta, type PerfilConta, type Sessao } from '../comum/conta.ts';
import { apelidoLiberado } from '../comum/presenca.ts';
import { Marca } from '@truco6/ui/Marca';
import { Tela } from './comum.tsx';

export const MENSAGEM_APELIDO_TROCADO = 'Seu apelido foi trocado porque não seguia as regras. Escolha outro.';

export function TrocarApelido({ sessao, perfil, aoTrocar }: { sessao: Sessao; perfil: PerfilConta; aoTrocar(apelido: string): void }) {
  const [apelido, setApelido] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function salvar(ev: React.FormEvent) {
    ev.preventDefault();
    const a = apelido.replace(/\s+/g, ' ').trim();
    if (!a) return setErro('Escolha um apelido.');
    if (ofensivo(a)) return setErro('Escolha outro apelido.');
    setEnviando(true);
    setErro(null);
    try {
      const r = await api<{ apelido: string }>(sessao, 'POST', '/perfil/apelido', { apelido: a });
      // No modo local o perfil fica no aparelho; no Supabase, a API já gravou.
      if (config.authLocal) await conta.salvarPerfil(sessao, { ...perfil, apelido: r.apelido });
      apelidoLiberado();
      aoTrocar(r.apelido);
    } catch (e) {
      setErro(e instanceof ErroDaApi ? e.message : 'Não deu para salvar. Tente de novo.');
      setEnviando(false);
    }
  }

  return (
    <Tela>
      <Marca altura={40} />
      <form className="form" onSubmit={salvar}>
        <h1>Escolha outro apelido</h1>
        <p role="alert">{MENSAGEM_APELIDO_TROCADO}</p>
        <label className="campo">
          <span>Apelido</span>
          <input value={apelido} maxLength={20} autoComplete="nickname" placeholder="Como a mesa te chama" autoFocus
            onChange={(ev) => setApelido(ev.target.value)} />
        </label>
        {erro && <p className="erro" role="alert">{erro}</p>}
        <button className="btn1 largo" disabled={enviando}>{enviando ? 'SALVANDO' : 'SALVAR APELIDO'}</button>
      </form>
    </Tela>
  );
}
